import axios from '@/util/axios';
import common from '../common'

export default {
  list(params) {
    return common.get('/rocheManage/sys/dict/list',params);
  },

  add(params) {
    return common.post('/rocheManage/sys/dict/add',params);
  },

  edit(params) {
    return common.put('/rocheManage/sys/dict/edit',params);
  },

  delete(params) {
    return common.delete('/rocheManage/sys/dict/delete',params);
  },  

  getDictItemsByCode(code) {
    return axios.get('/e2estservice/sys/dict/getDictItemsByCode/' + code);
  },

  getProvinceList() {
    return axios.post('/e2estservice/master/city/province-list');
  },

  getCityList(province) {
    let requestURL = '/e2estservice/master/city/city-list';
    requestURL = province ? (requestURL + '?province=' + province) : requestURL;
    return axios.post(requestURL);
  },

  getAribaCategoryList() {
    const requestURL = '/e2estservice/pub/ariba/aribaCategoryMap/list-all';
    return axios.get(requestURL);
  },
}



// WEBPACK FOOTER //
// ./src/api/sysmanagement/dictlist.js